var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2569_7350)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2569_7350",
    "mask-type": "luminance",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V25H25V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2569_7350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0703 0H2.92969C1.31167 0 0 1.31167 0 2.92969V22.0703C0 23.6883 1.31167 25 2.92969 25H22.0703C23.6883 25 25 23.6883 25 22.0703V2.92969C25 1.31167 23.6883 0 22.0703 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3779 4.88281H19.9623L14.3162 11.3359L20.9584 20.1172H15.7576L11.6842 14.7914L7.02322 20.1172H4.4373L10.4763 13.2148L4.10449 4.88281H9.43728L13.1193 9.75078L17.3779 4.88281ZM16.4709 18.5703H17.9029L8.65916 6.34844H7.12244L16.4709 18.5703Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2569_7350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5108a9eba5a9c023048dcc986a1e0768.svg";
export { ForwardRef as ReactComponent };